import { DOCUMENT_TYPE } from '../../../document/constants.ts';
import { faShoppingCart, faListCheck, faCommentDollar, faFileInvoiceDollar } from '@fortawesome/pro-regular-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { UseFormReturn } from 'react-hook-form';

interface ProductTypeConfig {
    type: DOCUMENT_TYPE;
    channelKey: string;
    icon: IconDefinition;
}

export const PRODUCT_TYPE_CONFIG: ProductTypeConfig[] = [
    { type: DOCUMENT_TYPE.ORDER, channelKey: 'orderProcessingChannels', icon: faShoppingCart },
    { type: DOCUMENT_TYPE.ORDER_CONFIRMATION, channelKey: 'orderConfirmationProcessingChannels', icon: faListCheck },
    { type: DOCUMENT_TYPE.REQUEST_FOR_QUOTATION, channelKey: 'rfqProcessingChannels', icon: faCommentDollar },
    { type: DOCUMENT_TYPE.INVOICE, channelKey: 'invoiceProcessingChannels', icon: faFileInvoiceDollar },
];

export const SUPPORTED_PRODUCT_TYPES = PRODUCT_TYPE_CONFIG.map((config) => config.type);

export const getProductTypeConfig = (type: DOCUMENT_TYPE): ProductTypeConfig | undefined =>
    PRODUCT_TYPE_CONFIG.find((config) => config.type === type);

export interface SmartInboxActionConfigType {
    id: string;
    eventKind: string;
    actionKind: string;
    actionConfig: string;
    __typename?: string;
}

export interface SmartInboxProductConfigType {
    documentType: string;
    channelId: string;
    channelName: string;
    actionConfigs: SmartInboxActionConfigType[];
    __typename?: string;
}
export const CustomCategoryActionKind = {
    TAG: 'TAG',
    MOVE_TO_FOLDER: 'MOVE_TO_FOLDER',
    MARK_AS_READ: 'MARK_AS_READ',
    CREATE_RECORD: 'CREATE_RECORD',
    FORWARD: 'FORWARD',
} as const;

export type CustomCategoryActionKind = (typeof CustomCategoryActionKind)[keyof typeof CustomCategoryActionKind];

export const ForwardOption = {
    EMAIL: 'EMAIL',
    WORKIST: 'WORKIST',
} as const;

export type ForwardOption = (typeof ForwardOption)[keyof typeof ForwardOption];

export interface CustomCategoryAction {
    id: string;
    actionKind: CustomCategoryActionKind;
    actionConfig: string;
}

export interface CustomCategoryActionInput {
    id?: string;
    actionKind: CustomCategoryActionKind;
    actionConfig: string;
}

export interface SmartInboxCustomCategoryType {
    id: string;
    name: string;
    detectionCriteria: string;
    supportingKeywords: string[];
    enabled: boolean;
    sourceType?: string;
    actions: CustomCategoryAction[];
}

export interface SmartInboxIntegrationType {
    id: string;
    name: string;
    mailInbox: string;
    enabled: boolean;
    isManualDocumentCreationEnabled?: boolean;
    ignoreReplyAndForwardedEmails?: boolean;
    useSmartInboxAsCreatedBy?: boolean;
    tenantId?: string;
    clientId?: string;
    destinationFolders?: Array<{ id: string; name: string }>;
    productConfigs?: SmartInboxProductConfigType[];
    customCategories?: SmartInboxCustomCategoryType[];
}

export interface SmartInboxFormData {
    name: string;
    tenantId: string;
    clientId: string;
    clientSecret: string;
    mailInbox: string;
    enabled: boolean;
    useSmartInboxAsCreatedBy: boolean;
    isManualDocumentCreationEnabled: boolean;
    ignoreReplyAndForwardedEmails: boolean;
    productConfigs: Record<
        string,
        { documentType: string; channelId: string | null; actionConfigs: Record<string, any> }
    >;
}

export interface SmartInboxConfigStepProps {
    form: UseFormReturn<SmartInboxFormData>;
    integration?: SmartInboxIntegrationType;
    channels?: Record<string, Array<{ id: string; name: string }>>;
    destinationFolders?: Array<{ id: string; name: string }>;
    isLoading?: boolean;
    isCreateMode?: boolean;
    isSharedInboxAdminConsentGranted?: boolean;
    selectedProductType?: string;
}
